// extracted by mini-css-extract-plugin
export var actionText = "_lb-4";
export var container = "_lb-0";
export var leftSection = "_lb-1";
export var rightSection = "_lb-2";
export var settingsButton = "_lb-6";
export var settingsIcon = "_lb-7";
export var shortcut = "_lb-5";
export var shortcutGroup = "_lb-3";